/** ログインリダイレクト用のパスを組み立て */
export function buildLoginRedirectPath(currentPath: string): string {
  return `/login?redirect=${encodeURIComponent(currentPath)}`
}

/**
 * ログイン後の戻り先として安全なアプリ内パスだけを通す。
 * 外部URLやプロトコル相対URLを渡すとオープンリダイレクトになるため null を返して弾く。
 */
export function sanitizeRedirectPath(raw: string | null): string | null {
  if (!raw) return null
  if (!raw.startsWith('/')) return null
  // '//host' や '/\host' はブラウザが外部URLとして解釈しうる
  if (raw.startsWith('//') || raw.startsWith('/\\')) return null
  return raw
}
